<template>
  <div
    :class="$vuetify.breakpoint.mdAndUp ? 'padding-lateral' : ''"
  >
    <Loading v-if="loading" />
    <ErrorServidor v-else-if="erro" />
    <template v-else>
      <v-row
        no-gutters
        :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : ''"
      >
        <v-col>
          <p
            class="mb-0 mt-2 caption grey--text text--lighten"
            data-cy="vendedor_label"
          >
            Vendedor
          </p>
          <p
            class="body-2 font-weight-bold"
            data-cy="vendedor_nome"
          >
            {{ nomeVendedor }}
          </p>
        </v-col>
        <v-btn
          :href="linkContatoSite"
          :disabled="linkContatoSite === null"
          target="_blank"
          data-cy="botao_contato_site"
          icon
        >
          <v-icon
            class="mx-2"
            color="primary"
          >
            mdi-home
          </v-icon>
        </v-btn>
        <v-btn
          :href="linkContatoEmail"
          :disabled="linkContatoEmail === null"
          target="_blank"
          data-cy="botao_contato_email"
          icon
        >
          <v-icon
            class="mx-2"
            color="primary"
          >
            mdi-email
          </v-icon>
        </v-btn>
        <v-btn
          :href="linkContatoTelefone"
          :disabled="linkContatoTelefone === null"
          target="_blank"
          data-cy="botao_contato_telefone"
          icon
        >
          <v-icon
            class="mx-2"
            color="primary"
          >
            mdi-phone
          </v-icon>
        </v-btn>
        <v-btn
          :href="linkContatoWhatsapp"
          :disabled="linkContatoWhatsapp === null"
          target="_blank"
          data-cy="botao_contato_whatsapp"
          icon
        >
          <v-icon
            class="mx-2"
            color="primary"
          >
            mdi-whatsapp
          </v-icon>
        </v-btn>
      </v-row>
      <v-row
        v-if="transportadora"
        no-gutters
        :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : ''"
      >
        <v-col>
          <p class="mb-0 caption grey--text text--lighten">
            Transportadora
          </p>
          <p class="body-2 font-weight-bold">
            {{ transportadora }}
          </p>
        </v-col>
      </v-row>
      <template v-if="rastreio.length === 0">
        <v-alert
          class="mt-10 elevation-1"
          dense
          outlined
          type="info"
        >
          <h3>Dados do rastreio não encontrado</h3>
          <p>Ainda não temos o status da sua entrega. Acesse novamente mais tarde.</p>
        </v-alert>
      </template>
      <template v-else>
        <TituloPagina :titulo="tituloDaPagina" class="mt-6 mb-4 mt-md-4" />
        <v-timeline
          dense
          align-top
          class="pt-0 mb-8 pt-md-1"
        >
          <v-timeline-item
            v-for="(item, index) in rastreio"
            :key="item.message"
            fill-dot
            data-cy="rastreio_timeline"
            small
            :class="{ 'active': index === 0 }"
          >
            <v-card
              class="px-5 py-4 grey--text text--darken-2"
              min-height="90"
              data-cy="card_item_rastreio"
            >
              <p data-cy="rastreio_timeline_data_hora">
                <strong class="title">
                  <span data-cy="rastreio_timeline_data">
                    {{ item.date | dataFormatada('numeric', '2-digit', '2-digit') }}
                  </span>,
                </strong>
                <span class="grey--text text--lighten-1">
                  {{ item.hour }}
                </span>
              </p>
              <p>
                <strong>
                  Status
                </strong> {{ item.status }}
              </p>
              <p v-if="item.location" class="mb-0">
                <strong>
                  Local
                </strong> {{ item.location }}
              </p>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </template>

      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        :to="urlVoltar"
        max-width="700px"
      />
      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp && !loading"
        :to="urlVoltar"
        class="mt-5"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
      >
        Voltar
      </v-btn>
    </template>
  </div>
</template>

<script>

import ApiCompras from '@/api/compras';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';

export default {
  name: 'RastreioTimeline',

  components: {
    TituloPagina,
    BtnVoltar,
    Loading,
    ErrorServidor,
  },

  props: {
    compraId: {
      type: Number,
      default: 0,
    },
    dadosRastreio: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      tituloDaPagina: 'Acompanhar envio',
      loading: true,
      rastreio: [],
      erro: false,
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
    ...mapState(['dadosTransacao']),

    urlVoltar() {
      if (this.compraId && this.dadosTransacao) {
        const { id } = this.dadosTransacao;
        return `/minhas-compras/detalhe-compra/${id}`;
      }
      return '/login';
    },

    nomeVendedor() {
      return this.dadosRastreio
        ? this.dadosRastreio.seller_name
        : this.dadosCompra.vendedor;
    },

    linkContatoEmail() {
      if (this.dadosRastreio && this.dadosRastreio.seller_contact_email) {
        return `mailto:${this.dadosRastreio.seller_contact_email}`;
      }
      if (this.dadosCompra && this.dadosCompra.vendedorEmail) {
        return `mailto:${this.dadosCompra.vendedorEmail}`;
      }
      return null;
    },

    linkContatoTelefone() {
      if (this.dadosRastreio && this.dadosRastreio.seller_contact_telephone) {
        return `tel:${this.dadosRastreio.seller_contact_telephone}`;
      }
      if (this.dadosCompra && this.dadosCompra.vendedorTelefone) {
        return `tel:${this.dadosCompra.vendedorTelefone}`;
      }
      return null;
    },

    linkContatoWhatsapp() {
      const subdominio = this.$vuetify.breakpoint.mdAndUp ? 'web' : 'api';
      if (this.dadosRastreio && this.dadosRastreio.seller_contact_whatsapp) {
        return `https://${subdominio}.whatsapp.com/send?l=pt_BR&phone=55${this.dadosRastreio.seller_contact_whatsapp}`;
      }
      if (this.dadosCompra && this.dadosCompra.vendedorWhatsapp) {
        return `https://${subdominio}.whatsapp.com/send?l=pt_BR&phone=55${this.dadosCompra.vendedorWhatsapp}`;
      }
      return null;
    },

    linkContatoSite() {
      if (this.dadosRastreio && this.dadosRastreio.seller_contact_website) {
        return this.dadosRastreio.seller_contact_website;
      }
      if (this.dadosCompra && this.dadosCompra.vendedorCentralDeAjuda) {
        return this.dadosCompra.vendedorCentralDeAjuda;
      }
      return null;
    },

    transportadora() {
      return this.dadosRastreio
        ? this.dadosRastreio.tracking_service_name
        : '';
    },
  },

  created() {
    this.verificarStore();
  },

  methods: {
    ...mapActions(['setDadosTransacao']),

    async carregarRastreio() {
      await ApiCompras.orderTracking(this.dadosTransacao.tracking_code,
        this.dadosTransacao.tracking_service_slug)
        .then((response) => {
          this.rastreio = response.data.data;
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async getApi(id) {
      this.erro = false;

      await ApiCompras.orderDetails(id)
        .then((response) => {
          this.data = response.data;
          this.setDadosTransacao(this.data);
          this.carregarRastreio();
        })
        .catch(() => {
          this.erro = true;
        });
    },

    validaDadosRastreio() {
      return this.dadosRastreio
        && this.dadosRastreio.tracking_history !== undefined
        && this.dadosRastreio.tracking_history.length;
    },

    validaDadosRastreioVendedor() {
      return this.dadosRastreio
        && !this.dadosRastreio.tracking_history.length
        && this.dadosRastreio.tracking_service_name
        && this.dadosRastreio.seller_name;
    },


    verificarStore() {
      if (this.compraId) {
        if (this.dadosTransacao.id === this.compraId) {
          this.carregarRastreio();
        } else {
          this.getApi(this.compraId);
        }
      } else if (this.validaDadosRastreio()) {
        this.rastreio = this.dadosRastreio.tracking_history;
        this.loading = false;
      } else if (this.validaDadosRastreioVendedor()) {
        this.rastreio = [];
        this.loading = false;
      } else {
        this.$router.push({
          name: 'login',
        });
      }
    },
  },

};
</script>

<style lang="scss" scope>
@import '~@/scss/timeline.scss';

.padding-lateral { padding: 0 100px; }
</style>
